export interface CustomError {
  code: string
  description: string
}

interface AppErrorProps {
  message: string
  status?: number
  errors?: CustomError[]
}

export class AppError extends Error {
  public readonly message: string
  public readonly status: number
  public readonly errors?: CustomError[]

  constructor({ message, status = 500, errors }: AppErrorProps) {
    super(message)
    this.message = message
    this.status = status
    this.errors = errors
  }
}
